import RequesterV1 from "@/components/api/v1/requester.js";

export default {

  fetchProviders(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_providers/${agro_exporter_process_id}`
    );
  },

  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchLiquidationMonthly(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_liquidations_monthly/${agro_exporter_process_id}`
    );
  },

  fetchTotalAdvances(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_total_advances/${agro_exporter_process_id}`
    );
  },

  fetchTotalsMonthly(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_totals_monthly/${agro_exporter_process_id}`
    );
  },

  fetchCropSizes(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_sizes/${agro_exporter_process_id}`
    );
  },

  fetchTotalsWeekly(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_totals_weekly/${agro_exporter_process_id}`
    );
  },

  fetchTotalsProvidersWeekly(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_totals_providers_weekly/${agro_exporter_process_id}`
    );
  },

  fetchCropSizeLabels(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_labels/${agro_exporter_process_id}`
    );
  },

  fetchCropSizeWeekly(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_weekly/${agro_exporter_process_id}`
    );
  },

  fetchCropSizeEarningWeekly(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `agro_exporter/liquidations/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_earning_weekly/${agro_exporter_process_id}`
    );
  },
}
